import "@diligentcorp/atlas-web-component-icons/lib/external-link/index.js";
import { html } from "lit";
import { choose } from "lit/directives/choose.js";
import { classMap } from "lit/directives/class-map.js";
import { when } from "lit/directives/when.js";
import { defineComponent } from "../../configuration/utils.js";
import { NavItem } from "./NavItem.js";
export class NavLink extends NavItem {
    constructor() {
        super();
        this.renderLink = () => {
            if (this.isDisabled) {
                return html `
        <div
          class=${classMap(this.linkClasses)}
          aria-label=${this.label}
          aria-current=${this.ariaCurrentValue}
          title=${this.label}
        >
          ${this.renderContents()}
        </div>
      `;
            }
            return html `
      <a
        href=${this.url}
        target=${this.target}
        class=${classMap(this.linkClasses)}
        aria-label=${this.label}
        aria-current=${this.ariaCurrentValue}
        title=${this.label}
      >
        ${this.renderContents()}
      </a>
    `;
        };
        this.renderButton = () => {
            return html `
      <button
        class=${classMap(this.linkClasses)}
        aria-label=${this.label}
        aria-current=${this.ariaCurrentValue}
        title=${this.label}
        ?disabled=${this.isDisabled}
      >
        ${this.renderContents()}
      </button>
    `;
        };
        this.renderSpan = () => {
            return html `
      <span
        class=${classMap(this.linkClasses)}
        aria-label=${this.label}
        aria-current=${this.ariaCurrentValue}
        title=${this.label}
      >
        ${this.renderContents()}
      </span>
    `;
        };
        this.as = "link";
        this.url = "";
        this.target = "_self";
        this.isDisabled = false;
        this.showExpandIcon = false;
        this.showExternalIcon = false;
    }
    render() {
        return choose(this.as, [
            ["link", this.renderLink],
            ["button", this.renderButton],
            ["span", this.renderSpan],
        ]);
    }
    renderContents() {
        return html `${super.renderContents()}${this.renderTrailingIcon()}`;
    }
    renderTrailingIcon() {
        return when(this.showExternalIcon, () => html `<dil-external-link-icon class="icon" aria-hidden="true"></dil-external-link-icon>`, () => when(this.showExpandIcon, this.renderExpandRightIcon));
    }
    get ariaCurrentValue() {
        return this.isCurrent ? "page" : "false";
    }
    get linkClasses() {
        return {
            ...super.itemClasses,
            disabled: this.isDisabled,
        };
    }
}
NavLink.properties = {
    ...NavItem.properties,
    as: { type: String, reflect: true, attribute: true },
    url: { type: String, reflect: true, attribute: true },
    target: { type: String, reflect: true, attribute: true },
    isDisabled: { type: Boolean, reflect: true, attribute: "is-disabled" },
    showExpandIcon: { type: Boolean, reflect: true, attribute: "show-expand-icon" },
    showExternalIcon: { type: Boolean, reflect: true, attribute: "show-external-icon" },
};
export const NAV_LINK_TAG = "atlas-gn-nav-link";
defineComponent(NAV_LINK_TAG, NavLink);
